import React from "react";
import LegalLayout, { LegalSection } from "./LegalLayout";

export default function Imprint() {
  return (
    <LegalLayout
      title="Imprint"
      subtitle="Mandatory disclosure pursuant to § 5 TMG (German Telemedia Act)."
    >
      <LegalSection title="Service Provider">
        <p>Vawick Consulting UG (haftungsbeschränkt)</p>
        <p>
          [Street and House Number]<br />
          [Postal Code] [City]<br />
          Germany
        </p>
      </LegalSection>

      <LegalSection title="Contact">
        <p>
          Email:{" "}
          <a
            href="mailto:support@vawick.de"
            className="text-white hover:text-[#FF4F00] transition-colors"
          >
            support@vawick.de
          </a>
        </p>
        <p>Phone: [Phone Number]</p>
      </LegalSection>

      <LegalSection title="Company Details">
        <p>Managing Director: [Name of Managing Director]</p>
        <p>Register Court: Amtsgericht [City]</p>
        <p>Registration Number: HRB [Number]</p>
        <p>VAT Identification Number (§ 27a UStG): DE [Number]</p>
      </LegalSection>

      <LegalSection title="Responsible for Content">
        <p>Pursuant to § 55 Abs. 2 RStV:</p>
        <p>[Name of Responsible Person] · [Address as above]</p>
      </LegalSection>

      <LegalSection title="Online Dispute Resolution">
        <p>
          The European Commission provides a platform for online dispute resolution (OS):{" "}
          <span className="text-white font-mono text-xs">https://ec.europa.eu/consumers/odr</span>
        </p>
        <p>
          We are not obligated or willing to participate in dispute resolution proceedings
          before a consumer arbitration board.
        </p>
      </LegalSection>

      <LegalSection title="Liability for Content">
        <p>
          As a service provider, we are responsible for our own content on these pages in accordance
          with general laws pursuant to § 7 Abs. 1 TMG. According to §§ 8 to 10 TMG, however, we are
          not obligated to monitor transmitted or stored third-party information or to investigate
          circumstances that indicate illegal activity.
        </p>
        <p>
          Obligations to remove or block the use of information in accordance with general laws remain
          unaffected. Liability in this regard is only possible from the time of knowledge of a specific
          legal violation. Upon notification of such violations, we will remove the content immediately.
        </p>
      </LegalSection>

      <LegalSection title="Liability for Links">
        <p>
          Our website contains links to external websites over which we have no control. We cannot
          accept any liability for these external websites. The respective provider or operator of
          the linked pages is always responsible for the content of those pages.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
